<template>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="pic">
          <div class="title">
            <div class="title-eng">info of provide for the aged</div>
            <div class="title-bold">养老资讯</div>
          </div>
        </div>
        <div class="content">
          <div class="content-list">
            <div class="provide-content">
              <div
                      class="provide-list"
                      v-for="item in topNews"
                      @click="provideDetail(item)"
              >
                <div class="provide-pic">
                  <img
                          :src="imgUrl + item.img"
                          alt=""
                          style="width: 100%; height: 100%"
                  />
                </div>
                <div class="provide-date">
                  <!--                                <div class="provide-day">6-25</div>-->
                  <div class="provide-year" v-html='updateTime(item.created)'></div>
                </div>
                <div class="provide-title">{{ item.title }}</div>
                <div class="provide-text" v-html='item.content'>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab">
          <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部" >
              <div class="provide-news">
                <div
                        class="news-content"
                        v-for="item in newsList"
                        @click="provideDetail(item)"
                >
                  <div class="news-date" v-html='updateTime(item.created)'></div>
                  <div class="news-text">
                    {{item.title}}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <template v-for='item in typeName'>
              <el-tab-pane :label="item.typeName" :name='item.id'>
                <div class="provide-news">
                  <div
                          class="news-content"
                          v-for="item in newsList"
                          @click="provideDetail(item)"
                  >
                    <div class="news-date"  v-html='updateTime(item.created)'></div>
                    <div class="news-text">
                      {{item.title}}
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import headerList from "./public/header";

  export default {
    name: "provide",
    components: { headerList },
    data() {
      return {
        userInfo: {
          id: "",
          username: "7777",
          avatar: "",
        },
        username: "",
        ativeName: "first",
        showMenu: false,
        wordtop: 0,
        flag: false,
        url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        imgUrl: "http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/",
        topNews: [],
        typeName: [],
        newsList: [],
      };
    },
    created() {
      this.initView();
      this.getNew();
      this.getList(1);
    },
    watch: {
      activeName: function (val) {
        //监听切换状态-计划单
        // let urlStr = '/index/test?tabid=' + val;
        // this.$router.push(urlStr);
        // 注释，根据val的不同，跳转到不同
      },
    },
    methods: {
      updateTime(item){
        let newList= item.split("T");
        return newList[0]
      },
      handleScroll: function () {
        if (document.body.scrollTop != 0) {
          this.wordtop = document.body.scrollTop;
        } else {
          this.wordtop = document.documentElement.scrollTop;
        }
        if (this.wordtop > 800) {
          this.showMenu = true;
        } else {
          this.showMenu = false;
        }
      },
      beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
      },
      handleClick(tab, event) {
        this.getNew(tab.name);
      },
      provideDetail(item) {
        //资讯详情
        this.$router.push({
          name: "information",
          // path:'/serviceList',
          query: item,
        });
      },
      initView() {
        this.$axios
                .post("/gw/new/top/1",{})
                .then((res) => {
                  this.topNews = res.data.data.records;
                  // this.newsList = res.data.data.records;
                });
      },
      getList() {
        this.$axios
                .get("/gw/new/type/list/1",)
                .then((res) => {
                  this.typeName = res.data.data.records;
                });
      },
      getNew(uid) {
           let obj = {};
        if (typeof uid == "undefined") {
          // obj.type = 1;
        }else{
        obj.type=uid;
        }
     
        this.$axios
                .post("/gw/new/list/1", obj)
                .then((res) => {
                  this.newsList = res.data.data.records;
                });
      },
    },
  };
</script>

<style scoped>
  .box {
    position: relative;
    top: 0;
    left: 0;
    padding: 0;
    margin: auto;
  }

  .el-container {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
  }
  .el-header {
    width: 100%;
    height: 7.1875rem /* 115px -> 7.1875rem */ !important;
    line-height: 7.1875rem /* 115px -> 7.1875rem */;
    background-color: #fff;
    color: #333;
    text-align: center;
    position: fixed;
    background: rgba(255, 255, 255, 0.8);
    top: 0;
    left: 0;
    z-index: 99;
  }

  .el-main {
    color: #333;
    padding: 0;
    width: 100%;
  }
  .pic {
    width: 100%;
    height: 39.875rem /* 638px -> 39.875rem */;
    background: url("../assets/image/bg6.jpeg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    left: 0;
    top: 0;
  }
  .title {
    width: 24.0625rem /* 385px -> 24.0625rem */;
    height: 7.9375rem /* 127px -> 7.9375rem */;
    position: absolute;
    bottom: 0;
    right: 16.375rem /* 262px -> 16.375rem */;
    background: #f77f00;
    opacity: 0.9;
    color: #fff;
  }
  .title-eng {
    width: 17.5rem /* 280px -> 17.5rem */;
    height: 0.8125rem /* 13px -> .8125rem */;
    font-size: 1rem /* 16px -> 1rem */;
    font-family: Arial;
    font-weight: bold;
    color: #ffffff;
    line-height: 3.75rem /* 60px -> 3.75rem */;
    margin-left: 0.9375rem /* 15px -> .9375rem */;
  }
  .title-bold {
    width: 10.0625rem /* 161px -> 10.0625rem */;
    height: 2.375rem /* 38px -> 2.375rem */;
    font-size: 2.375rem /* 38px -> 2.375rem */;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 6.6875rem /* 107px -> 6.6875rem */;
    margin-left: 0.9375rem /* 15px -> .9375rem */;
  }
  .content {
    height: 30rem /* 480px -> 30rem */;
  }
  .content-list {
    margin: 5rem /* 80px -> 5rem */ 13.75rem /* 220px -> 13.75rem */;
  }
  .provide-content {
    width: 90% /* 1380px -> 86.25rem */;
    height: 23.125rem /* 370px -> 23.125rem */;
    margin: 1.25rem /* 20px -> 1.25rem */ auto;
  }
  .provide-list {
    width: 29% /* 438px -> 27.375rem */;
    height: 23.125rem /* 370px -> 23.125rem */;
    margin: 0 2% /* 10px -> .625rem */;
    float: left;
    border: 1px solid transparent;
  }
  .provide-list:hover {
    border: 1px solid #f77f00;
  }
  .provide-pic {
    width: 98% /* 408px -> 25.5rem */;
    height: 13.9375rem /* 223px -> 13.9375rem */;
    margin: 1% /* 15px -> .9375rem */;
  }
  .provide-date {
    height: 1.875rem /* 30px -> 1.875rem */;
    line-height: 1.875rem /* 30px -> 1.875rem */;
    margin: 0.9375rem /* 15px -> .9375rem */;
  }
  .provide-day {
    width: 2.6875rem /* 43px -> 2.6875rem */;
    height: 0.9375rem /* 15px -> .9375rem */;
    font-size: 1.25rem /* 20px -> 1.25rem */;
    font-family: Arial;
    font-weight: 400;
    color: #f77f00;
    float: left;
  }
  .provide-year {
    width: 100%;
    height: 0.75rem /* 12px -> .75rem */;
    font-size: 1rem /* 16px -> 1rem */;
    font-family: Arial;
    font-weight: 400;
    color: #f77f00;
    float: right;
    text-align: right;
  }
  .provide-title {
    width: 11.875rem /* 190px -> 11.875rem */;
    height: 2rem /* 32px -> 2rem */;
    font-size: 0.875rem /* 14px -> .875rem */;
    line-height: 2rem /* 32px -> 2rem */;
    font-family: Arial;
    font-weight: 400;
    color: #f77f00;
    text-align: left;
    margin: 0 0.9375rem /* 15px -> .9375rem */;
  }
  .provide-text {
    width: 25rem /* 400px -> 25rem */;
    height: 2rem /* 32px -> 2rem */;
    font-size: 0.75rem /* 12px -> .75rem */;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #000000;
    line-height: 1.25rem /* 20px -> 1.25rem */;
    margin: 0 0.9375rem /* 15px -> .9375rem */;
  }
  .provide-news {
    width: 87.5rem /* 1400px -> 87.5rem */;
    height: 25rem /* 400px -> 25rem */;
    margin: 3.125rem /* 50px -> 3.125rem */ auto;
  }
  .news-content {
    width: 86.25rem /* 1380px -> 86.25rem */;
    height: 5rem /* 80px -> 5rem */;
    border: 1px solid transparent;
  }
  .news-content:hover {
    background: #fdfbf5;
    color: #f77f00;
    border: 1px solid #f77f00;
  }
  .news-date {
    width: 30% /* 400px -> 25rem */;
    height: 5rem /* 80px -> 5rem */;
    line-height: 5rem /* 80px -> 5rem */;
    font-size: 0.75rem /* 12px -> .75rem */;
    font-family: Arial;
    font-weight: 400;
    float: left;
    text-align: left;
  }
  .news-text {
    width: 69% /* 980px -> 61.25rem */;
    height: 5rem /* 80px -> 5rem */;
    line-height: 5rem /* 80px -> 5rem */;
    float: left;
    text-align: left;
    font-size: 1rem /* 16px -> 1rem */;
    font-family: Arial;
    font-weight: 400;
  }
  .el-pagination {
    width: 22.5rem /* 360px -> 22.5rem */;
    height: 2.1875rem /* 35px -> 2.1875rem */;
    margin-left: 29.375rem /* 470px -> 29.375rem */;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f77f00;
    color: #fff;
  }
  .tab {
    margin: 0 16.25rem /* 260px -> 16.25rem */;
  }
  ::v-deep .el-tabs__item {
    width: 15.375rem /* 246px -> 15.375rem */;
    height: 5.4375rem /* 87px -> 5.4375rem */;
    line-height: 5.4375rem /* 87px -> 5.4375rem */;
    background: #eceae3;
    text-align: center;
    margin: 0 0.75rem /* 12px -> .75rem */;
    border-radius: 1.25rem /* 20px -> 1.25rem */;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
  }
  ::v-deep .el-tabs--card > .el-tabs__header {
    border: none;
  }
 ::v-deep .el-tabs__item.is-active {
    background: #f77f00;
    color: #fff;
  }
</style>
